import styled from 'styled-components';

import Icon from '../Icon';

export const IconButton = ({
	svg,
	url,
	alt,
	onClick,
	width = 24,
	height = 24,
	disabled = false,
	title = '',
	active = false
}: IconButtonProps): JSX.Element => {
	return (
		<Button disabled={disabled} onClick={onClick}>
			<Icon
				$svg={svg}
				$url={url}
				alt={alt}
				$width={width}
				$height={height}
				$title={title}
				$active={active}
			/>
		</Button>
	);
};

const Button = styled.button`
	border: none;
	background-color: transparent;
	outline: none;
	&:focus {
		outline: none;
	}
	padding: 0;
	margin: 0;
`;

export interface IconButtonProps {
	svg?: JSX.Element;
	url?: string;
	alt?: string;
	onClick?: () => void;
	width?: number;
	height?: number;
	disabled?: boolean;
	title?: string;
	active?: boolean;
}

export default IconButton;
